import React from 'react'

import classNames from 'classnames'

import useNavigateParams from '@hooks/useNavigateParams'
import SearchService, { SearchCategory } from '@services/SearchService'

interface Props {
  category: SearchCategory
  title: string
  isSelected: boolean
}

const SearchItem: React.FC<Props> = ({ category, title, isSelected }: Props) => {
  const navigate = useNavigateParams()
  const onClick = (): void => SearchService.performSearch(category, title, navigate)
  switch (category) {
    case SearchCategory.MARKETPLACE_WITH_CONTRIBS:
      return (
        <ResultItem title={title} icon="nf-music-sm" onClick={onClick} isSelected={isSelected} />
      )
    case SearchCategory.GROUP:
      return (
        <ResultItem
          title={title}
          icon="nf-community-sm"
          onClick={onClick}
          isSelected={isSelected}
        />
      )
    case SearchCategory.COMMUNITY_MEMBER:
      return <ResultItem title={title} icon="nf-avatar" onClick={onClick} isSelected={isSelected} />
    case SearchCategory.SCORE:
      return <ResultItem title={title} icon="nf-note" onClick={onClick} isSelected={isSelected} />
    case SearchCategory.YOUR_HOME:
      return <ResultItem title={title} icon="nf-note" onClick={onClick} isSelected={isSelected} />
    case SearchCategory.TITLE:
      return (
        <ResultItem title={title} icon="nf-music-sm" onClick={onClick} isSelected={isSelected} />
      )
    default:
      // Not implemented
      throw new Error('Search item not implemented')
  }
}
export default SearchItem

interface ResultItemProps {
  title: string
  icon: string
  onClick: () => void
  isSelected: boolean
}
const ResultItem: React.FC<ResultItemProps> = ({
  title,
  icon,
  onClick,
  isSelected,
}: ResultItemProps) => (
  <button
    onClick={onClick}
    className={classNames(
      'flex flex-row items-center p-1 my-1.5 sm:my-1 w-full rounded hover:bg-gray-highlight focus:bg-gray-highlight dark:hover:bg-gray-highlight-dm dark:focus:bg-gray-highlight-dm outline-none',
      { 'bg-gray-highlight dark:bg-gray-highlight-dm': isSelected }
    )}>
    <i
      className={`nf-icon ${icon} text-xl w-6 text-center mr-2 text-gray-icons dark:text-gray-icons-dm`}
    />
    <span className="text-base sm:text-sm text-left ellipsify dark:text-gray">{title}</span>
  </button>
)
